module.exports = __webpack_public_path__ + "7d124dee510706bee97c7d3fdece2a0f.png";